import React, { useState, useRef } from "react";
import { Box, Paper, Typography, TextField, IconButton, Button } from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import { useNavigate } from "react-router-dom";
import chatWall from "../../asset/chatWall5.jpeg";

const DemoChat = () => {
  const [messages, setMessages] = useState([
    {
      sender: "bot",
      text: "Hi! I’m Mebot 😄. How can I help you today?",
      isTypingComplete: true
    },
  ]);
  const [input, setInput] = useState("");
  const messagesEndRef = useRef(null);
  const navigate = useNavigate();

  // Function to simulate bot reply
  const getBotReply = (userMessage) => {
    // You can replace this with AI API call later
    if (!userMessage) return "Can you please say something?";
    return `How can I assist further?`;
  };

  const handleSend = () => {
    if (!input.trim()) return;

    // Add user's message
    setMessages(prev => [...prev, { sender: "user", text: input }]);

    const userText = input; // Save input for bot reply
    setInput("");

    // Simulate bot typing delay
    setTimeout(() => {
      const botReply = getBotReply(userText);
      setMessages(prev => [
        ...prev,
        { sender: "bot", text: botReply, isTypingComplete: true }
      ]);

      // Scroll to bottom after bot message
      messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
    }, 1);

    // Scroll to bottom immediately after user message
    setTimeout(() => {
      messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
    }, 1);
  };


  return (
    <Box
      sx={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        backgroundImage: `url(${chatWall})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundColor: "#eaf3f8", // subtle blue overlay
      }}
    >
      {/* Chat Header with Back Button */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          p: 2,
          background: "#000814",
          color: "white",
          fontWeight: 600,
          fontSize: "1.2rem",
        }}
      >
        <Typography variant="h5">AI-MeBot Chat 💬</Typography>
        <Button
          variant="contained"
          sx={{
            bgcolor: "#ffffffaa",
            color: "#0a3952",
            borderRadius: "12px",
            px: 2,
            "&:hover": { bgcolor: "#f0f0f0" },
          }}
          onClick={() => navigate("/dashboard")}
        >
          Back to Dashboard
        </Button>
      </Box>

      {/* Chat Messages */}
      <Box
        sx={{
          flex: 1,
          overflowY: "auto",
          display: "flex",
          flexDirection: "column",
          gap: 2,
          p: 2,
        }}
      >
        {messages.map((msg, index) => (
          <Paper
            key={index}
            elevation={2}
            sx={{
              maxWidth: "60%",
              p: 1.5,
              borderRadius: 3,
              alignSelf: msg.sender === "user" ? "flex-end" : "flex-start",
              backgroundColor: msg.sender === "user" ? "#1baac7" : "#f1f5f9",
              color: msg.sender === "user" ? "white" : "#0a3952",
              fontSize: "0.95rem",
            }}
          >
            <Typography>{msg.text}</Typography>
          </Paper>
        ))}
        <div ref={messagesEndRef}></div>
      </Box>

      {/* Input Area */}
      <Box
        sx={{
          display: "flex",
          p: 2,
          borderTop: "1px solid rgba(255,255,255,0.3)",
          backgroundColor: "transparent",
          backdropFilter: "blur(8px)",
        }}
      >
        <TextField
          fullWidth
          placeholder="Type a message..."
          variant="outlined"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && handleSend()}
          sx={{
            mr: 1,
            "& .MuiOutlinedInput-root": {
              borderRadius: "12px",
              backgroundColor: "rgba(255,255,255,0.8)",
              backdropFilter: "blur(4px)",
            },
          }}
        />
        <IconButton
          color="primary"
          onClick={handleSend}
          sx={{
            borderRadius: "12px",
            bgcolor: "#1baac7",
            color: "white",
            "&:hover": { bgcolor: "#148ea5" },
          }}
        >
          <SendIcon />
        </IconButton>
      </Box>
    </Box>
  );
};

export default DemoChat;